// DM Sans: the xxllnc.ai house font, self-hosted in public/fonts (no external CDN).
const body = ["'DM Sans'", 'Helvetica', 'Arial', 'sans-serif'].join(',')

export const typography = {
  headline: body,
  body,
  subtitle: body,
  button: body,
  overline: body,
  caption: body,
}
